import './App.css';
import React, { useEffect, useState } from "react";

var freezepage = false;

var selectedCategory = 'gk'; // Default category
var currentuserid = '';

// Check if the URL has a query string and extract the CategoryName if it exists
let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      selectedCategory = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}

function Questions() { 

const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; // 'http://localhost:3000' ; //
//console.log('KC_SERVICE:', KC_SERVICE);
  
const [question, setQuestion] = useState(null);
const [selectedOption, setSelectedOption] = useState('');
const [loading, setLoading] = useState(true);
const [timeLeft, setTimeLeft] = useState(0);
//const [timerAtSubmit, settimerAtSubmit] = useState(0);
const [isTimeUp, setIsTimeUp] = useState(false);
const [overallScore, setOverallScore] = useState(0);
//const [data, setResponses] = useState([]);


// show timer countdown
useEffect(() => {
  if (timeLeft > 0) {
    const timerId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(timerId);
  } else {
    setIsTimeUp(true);
  }
}, [timeLeft]);

// get overall score
useEffect(() => {
  async function fetchScore() {
    if (!currentuserid) return;
    
    const response = await fetch(KC_SERVICE + '/userresponses_getuserscore', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId: currentuserid.split('-')[0] }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

  const result = await response.json();
  console.log('Fetched userscores1:', result.UserScore);
  // console.log(Array.isArray(result.UserScore));

  // const scoreData = Array.isArray(result.UserScore) ? result.UserScore : [];
  setOverallScore(result.UserScore);
  // console.log('P1ointsWeightage:2', scoreData);
  }

  fetchScore();
}, [KC_SERVICE]);   

  /* Show KnowledgeScore */
  useEffect(() => {
    async function handleTimeOver() {
      if (timeLeft === 0 && !freezepage) {
        //alert('Time over!');
        //const selectedOptionElem = document.querySelector('input[name="option"]:checked');
        //const answerSelected = selectedOptionElem ? selectedOptionElem.nextSibling.textContent.trim() : '';
        if (!question) return; // Prevent error if question is null
        const questionId = question.id;
        const timestamp = new Date().toISOString();
        const timeTaken = question.MaxScreenTime;
        //const isCorrect = question.Answer === answerSelected;

        console.log("sending empty response to api");

        const response = await fetch(KC_SERVICE + '/userresponses_insertrecord', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            userId: currentuserid.split('-')[0],
            questionId: questionId,
            response: '',
            responseDateTime: timestamp, 
            timeTaken: timeTaken,
            category: selectedCategory,
            pointsReceived: question.IncorrectPoints
          }),
        });
    
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        //const result = await response.json();
      }
    }
    handleTimeOver();
  }, ); // [timeLeft]

// get question from database to show on screen
useEffect(() => {
  async function fetchQuestion() {
    setLoading(true);
    const response = await fetch(KC_SERVICE + '/practice_getNextQuestion', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        userId: currentuserid.split('-')[0],
        categoryId: selectedCategory
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    else
    {
      const result = await response.json();
      console.log('Fetched CategoryName:', result.Question.QuestionText);
      console.log(Array.isArray(result.Question));
  
      if(result.Question === null || result.Question.length === 0) {
        // No more questions available in this category
        //alert("No more questions available in this category.");
        setLoading(false);
        return;
      }
      setQuestion(result.Question);
      setTimeLeft(result.Question.MaxScreenTime);
    }


    // ------
    // if (!error) {
    //   if(data === null || data.length === 0) {
    //     // No more questions available in this category
    //     //alert("No more questions available in this category.");
    //     setLoading(false);
    //     return;
    //   }
    //   setQuestion(data);
    //   setTimeLeft(data.MaxScreenTime);
    // }
    // else {  
    //   //alert('23' + error.message); 
    // }



    setLoading(false);
  }
  fetchQuestion();
}, [KC_SERVICE]);

useEffect(() => {
  async function fetchCategoryName() {
    if (!selectedCategory) return;

    const response = await fetch(KC_SERVICE + '/category_getname', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        categoryId: selectedCategory
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    else
    {
      const result = await response.json();
      console.log('Fetched CategoryName:', result.Category.CategoryName);
      // console.log(Array.isArray(result.CategoryName));
  
      //if (!error && result) {
        // Show category name in an element with id 'category-label'
        const label = document.getElementById('category-label');
        if (label) {
          label.innerText = "Category: " + result.Category.CategoryName;
        }
      //}
    }

  }
  fetchCategoryName();
}, [KC_SERVICE]); // [selectedCategory]

// handle option change
const handleOptionChange = (e) => {
  setSelectedOption(e.target.value);
};

// move to next question
function navigateToQuestions(){
  window.location.href = window.location.pathname + "?pageName=Question&CategoryName=" + selectedCategory + "&userid=" + currentuserid;
  return;
};

// on submit click
const handleSubmit = async () => {  
  document.querySelector('button[type="submit"]').style.display = 'none';
  freezepage = true
  // Capture the current timer value in a separate variable
  //settimerAtSubmit(timeLeft);
  const selectedOption = document.querySelector('input[name="option"]:checked');
  if (!selectedOption) {
    alert("Please select an option before submitting.");
    return;
  }

  const answerSelected = `${selectedOption.nextSibling.textContent.trim()}`;
  const questionId = question.id;
  const timestamp = new Date().toISOString();
  const timeTaken = question.MaxScreenTime - timeLeft;
  const isCorrect = question.Answer === selectedOption.nextSibling.textContent.trim();

  if (isCorrect) {
    //alert(`Correct! You earned ${question.CorrectPoints} points.`);

    selectedOption.style.fontWeight = 'bold';
    selectedOption.style.color = 'green';
    const tickIcon = selectedOption.parentElement.querySelector('.tick-icon');
    if (tickIcon) {
      tickIcon.style.display = 'inline';
    }
  } 
  else {
    //alert(`Incorrect! You lost ${question.IncorrectPoints} points.`);

    const correctoption = document.querySelector(`input[name="option"][value="${question.Answer}"]`);
    correctoption.parentElement.style.fontWeight = 'bold';
    correctoption.parentElement.style.color = 'green';
    const tickIcon = correctoption.parentElement.querySelector('.tick-icon');
    if (tickIcon) {
      tickIcon.style.display = 'inline';
    }

    selectedOption.parentElement.style.fontWeight = 'bold';
    selectedOption.parentElement.style.color = 'red';
    const crossIcon = selectedOption.parentElement.querySelector('.cross-icon');
    if (crossIcon) {
      crossIcon.style.display = 'inline';
    }
  }

  if (question.AnswerExplanation) {
    const explanationBox = document.getElementById('answer-explanation-box');
    if (explanationBox) {
      explanationBox.style.display = 'block';
    }
  }

  // Save response to database
  const response = await fetch(KC_SERVICE + '/userresponses_insertrecord', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ 
      userId: currentuserid.split('-')[0],
      questionId: questionId,
      response: answerSelected,
      responseDateTime: timestamp, 
      timeTaken: timeTaken,
      category: selectedCategory,
      pointsReceived: isCorrect ? question.CorrectPoints : question.IncorrectPoints
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
};

if (loading) {
  return <div>Loading...</div>;
}

if (!question) {
  return (
    <div style={{ background: '#f0f4f8', padding: '24px', borderRadius: '8px', maxWidth: 800 }}>
      <h2>Congratulations! 🎉</h2>
      <p>
        You have completed all questions in this category.<br />
        Try exploring other categories to keep learning and earning more points!<br />
        New questions are added regularly, so please visit again after some time for more challenges.
      </p>
    </div>
  )
}

return (
  <div style={{ padding: '24px', maxWidth: 800 }}>
    {/* Show overall score */}
    <div
      style={{
        marginBottom: '1.2rem',
        padding: '0.5rem 1rem',
        background: '#e9f7ef',
        borderRadius: '6px',
        fontSize: '1.1rem',
        color: '#155724',
        border: '1px solid #c3e6cb',
        maxWidth: '400px'
      }}
    >
      <strong>My total Points:</strong> {overallScore} <br />

          </div>

          {!freezepage && (
            <p
        id="timer"
        style={{
          color: timeLeft <= 10 ? 'red' : 'black',
          fontSize: '24px',
          fontFamily: 'Georgia, serif'
        }}
            >
        {timeLeft} seconds remaining
            </p>
          )}

          <div style={{ fontSize: '0.95rem', marginBottom: '1rem', color: '#555' }}>
            <label id="category-label" style={{ marginRight: '8px', fontWeight: 'bold' }}>
        {/* Show category name directly */}
          Category: {question.Category?.CategoryName || selectedCategory}
        </label>
      </div>
      <h2>{question.QuestionText}</h2>
      <div>
        <label>
        <input
          type="radio"
          value={question.Option1}
          checked={selectedOption === question.Option1}
          onChange={handleOptionChange}
          name="option"
          disabled={(timeLeft === 0) || freezepage}
        />
        {question.Option1}
        <span
          className="tick-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'green' }}
        >
          &#10003;
        </span>
        <span
          className="cross-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'red' }}
        >
          &#10007;
        </span>
        </label>
      </div>
      <br />
      <div>
        <label>
        <input
          type="radio"
          value={question.Option2}
          checked={selectedOption === question.Option2}
          onChange={handleOptionChange}
          name="option"
          disabled={(timeLeft === 0) || freezepage}
        />
        {question.Option2}
        <span
          className="tick-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'green' }}
        >
          &#10003;
        </span>
        <span
          className="cross-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'red' }}
        >
          &#10007;
        </span>
        </label>
      </div>
      <br />
      <div>
        <label>
        <input
          type="radio"
          value={question.Option3}
          checked={selectedOption === question.Option3}
          onChange={handleOptionChange}
          name="option"
          disabled={(timeLeft === 0) || freezepage}
        />
        {question.Option3}
        <span
          className="tick-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'green' }}
        >
          &#10003;
        </span>
        <span
          className="cross-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'red' }}
        >
          &#10007;
        </span>
        </label>
      </div>
      <br />
      <div>
        <label>
        <input
          type="radio"
          value={question.Option4}
          checked={selectedOption === question.Option4}
          onChange={handleOptionChange}
          name="option"
          disabled={(timeLeft === 0) || freezepage}
        />
        {question.Option4}
        <span
          className="tick-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'green' }}
        >
          &#10003;
        </span>
        <span
          className="cross-icon"
          style={{ display: 'none', marginLeft: '8px', color: 'red' }}
        >
          &#10007;
        </span>
        </label>
      </div>
      <br />
      <button
        type="submit"
        onClick={() => {
        // Pause the timer by preventing further countdown (do not setTimeLeft to 0)
        freezepage = true;
        //setTimeLeft(prev => prev); // This will freeze the timer by not changing its value
        handleSubmit();
        }}
        style={{
        fontSize: '1.5rem',
        padding: '0.75rem 2rem',
        marginTop: '1rem',
        borderRadius: '8px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        cursor:
          timeLeft === 0
          ? 'not-allowed'
          : (!selectedOption || timeLeft > (question.MaxScreenTime - question.MinScreenTime))
          ? 'not-allowed'
          : 'pointer',
        opacity:
          timeLeft === 0 ||
          (!selectedOption || timeLeft > (question.MaxScreenTime - question.MinScreenTime))
          ? 0.6
          : 1
        }}
        disabled={
        timeLeft === 0 ||
        !selectedOption ||
        timeLeft > (question.MaxScreenTime - question.MinScreenTime)
        }
      >
        {timeLeft === 0
        ? 'TimeOut'
        : timeLeft > (question.MaxScreenTime - question.MinScreenTime)
        ? `Wait... (${timeLeft - (question.MaxScreenTime - question.MinScreenTime)}s)`
        : 'Submit'}
      </button>
      {/* Scoring info below submit button */}
    <div
      style={{
        marginTop: '1.2rem',
        padding: '0.75rem 1.2rem',
        background: '#f8f9fa',
        borderRadius: '6px',
        fontSize: '1.05rem',
        color: '#333',
        border: '1px solid #e0e0e0',
        maxWidth: '400px'
      }}
    >
      <strong>Scoring for this question:</strong>
      <ul style={{ margin: '0.5em 0 0 1.2em', padding: 0 }}>
        <li>
          <span style={{ color: 'green', fontWeight: 500 }}>
            +{question.CorrectPoints}
          </span>{" "}
          points for a correct answer
        </li>
        <li>
          <span style={{ color: 'red', fontWeight: 500 }}>
            {question.IncorrectPoints}
          </span>{" "}
          points for an incorrect answer
        </li>
        {/* <li>
         Knowledge level <span style={{ color: '#6f42c1', fontWeight: 500 }}>
            : {question.KnowledgeScore}
          </span>{" "}
          
        </li> */}
      </ul>
      {/* <div style={{ fontSize: '0.95rem', color: '#888', marginTop: '0.5em' }}>
        Points are for vouchers only. Knowledge Score will not be redeemed.
      </div> */}
      {question.AnswerExplanation && (
        <div
          id="answer-explanation-box"
          style={{
            marginTop: '1.2rem',
            padding: '0.75rem 1.2rem',
            background: '#fff3cd',
            borderRadius: '6px',
            fontSize: '1.05rem',
            color: '#856404',
            border: '1px solid #ffeeba',
            maxWidth: '400px',
            display: freezepage ? 'block' : 'none'
          }}
        >
          <strong>Explanation:</strong> {question.AnswerExplanation}
        </div>
      )}
    </div>
    {((timeLeft === 0) || freezepage) && (
      <button
        type="button"
        style={{
          fontSize: '1.2rem',
          padding: '0.5rem 1.5rem',
          marginTop: '1rem',
          marginLeft: '1rem',
          borderRadius: '8px',
          backgroundColor: '#28a745',
          color: '#fff',
          border: 'none',
          cursor: 'pointer'
        }}
        onClick={navigateToQuestions}
      >
        Next
      </button>
    )}
    {isTimeUp && freezepage && (
      <div style={{ marginTop: '1rem' }}>
        {selectedOption && (
          question.Answer === selectedOption ? (
            <span style={{ color: 'green', fontWeight: 'bold', fontSize: '1.2rem' }}>
              Correct Answer
            </span>
          ) : (
            <span style={{ color: 'red', fontWeight: 'bold', fontSize: '1.2rem' }}>
              Incorrect answer
            </span>
          )
        )}
      </div>
    )}
  </div>
);
}

export default Questions;